/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

const AddTagModal = ({ moduleName, selectedId, onModalClose }) => {
  const token = localStorage.getItem("token");

  const [tagName, setTagName] = useState("");

  const [tagList, setTagList] = useState([]);

  const [tagWarning, setTagWarning] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);

  //function for create new tag
  const createNewTagHandler = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_CREATE_NEW_TAG + `?token=${token}`;

      let tagData = {
        title: tagName,
        slug: tagName,
      };

      const response = await postData(requestUrl, tagData);

      console.log(response);

      if (response.status) {
        setTagName("");
        getAllTags();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // function for set tags
  const tagselectedHandler = (data) => {
    let prevTags = selectedTags;

    if (prevTags.includes(data.value)) {
      let selectedTagItem = document.getElementById("tagdata-" + data.value);
      selectedTagItem.classList.remove("active");
      // exist in array, thus remove
      let key = prevTags.indexOf(data.value);
      prevTags.splice(key, 1);
    } else {
      let selectedTagItem = document.getElementById("tagdata-" + data.value);
      selectedTagItem.classList.add("active");
      // not exist in array, thus add
      prevTags.push(data.value);
    }

    setSelectedTags(prevTags);
  };

  //function for remove active class for selected tags
  const removeActiveClass = () => {
    const liElements = document.querySelectorAll(".tag");

    liElements.forEach((li) => {
      li.classList.remove("active");
    });
  };

  // remove active class after close modal
  const resetSelectTags = () => {
    let resetBlock = document.getElementsByClassName("tagblock");
    for (let i = 0; i < resetBlock.length; i++) {
      resetBlock[i].classList.remove("active");
    }
  };

  //function for close modal
  const closeModalhandler = () => {
    setTagName("");
    setSelectedTags([]);
    removeActiveClass();
    resetSelectTags();
    setTagWarning(false);
  };

  //function for save tag to user
  const addRemoveTagHandler = async (action) => {
    try {
      let requestUrl = url.API_BASE_URL;

      // // select request url based on which module this label component is working on
      if (moduleName === "appuser") {
        requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_APP_USER;
      } else if (moduleName === "companydetails") {
        requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COMPANY;
      } else if (moduleName === "eventdetails") {
        requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_EVENT;
      } else if (moduleName == "groupdetails") {
        requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_GROUP;
      } else if (moduleName == "activity") {
        requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_FORUM;
      } else {
        alert("error in module selection. please refresh once");
      }

      setIsUpdating(true);

      // // run a loop for all selected components or checkboxId

      let tagUpdateUrl =
        requestUrl + `/${selectedId}` + `?token=${token}` + `&action=${action}`;
      // console.log("tagUpdateUrl --------->", tagUpdateUrl);

      const response = await putData(tagUpdateUrl, selectedTags);
      console.log("response in add remove tag-------->", response);

      setIsUpdating(false);
      closeModalhandler();

      // close the modal of addLabel
      let tagModal = document.querySelector("#addtag_mdl");
      let modal = bootstrap.Modal.getInstance(tagModal);
      modal.hide();

      //display thanks modal
      // let thanksModal = new bootstrap.Modal(
      //   document.getElementById("success_mdl")
      // );
      // thanksModal.show();
      onModalClose();
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getAllTags();
  }, []);

  return (
    <div className="chat_modalbx">
      <div
        className="modal fade show"
        id="addtag_mdl"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 px-4">
              <div className="modal_hdng">
                <h3 className="text-primary text-uppercase fs-lg">Add Tags</h3>
              </div>
              <button
                type="button"
                className="close d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModalhandler}
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>
            <div className="modal-body">
              <div className="group_srchfill add_fill position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter to create new tag"
                  value={tagName}
                  onChange={(e) => setTagName(e.target.value)}
                />
                <Link
                  to="#"
                  className="add_icon position-absolute"
                  onClick={createNewTagHandler}
                >
                  <span className="material-icons-round text-pink">
                    add_circle{" "}
                  </span>
                </Link>
              </div>
              <div className="group_innrScroll mt-3">
                <div className="tag_links">
                  <ul className="list_style_none d-flex flex-wrap gap-2">
                    {/* <li className="active">
                      <Link
                        to="#"
                        className="rounded-90 d-flex align-items-center justify-content-center fw-medium fs-sm"
                      >
                        UX Design
                      </Link>
                    </li> */}
                    {tagList.map((tag, index) => {
                      return (
                        <li
                          className="tag"
                          key={index}
                          id={"tagdata-" + tag.value}
                        >
                          <Link
                            to="#"
                            onClick={() => tagselectedHandler(tag)}
                            className="rounded-90 d-flex align-items-center justify-content-center fw-medium fs-sm"
                          >
                            {tag.label}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="add_deleteouter d-flex gap-3 mt-3">
                <div className="add_btn w-50">
                  <Link
                    to="#"
                    className="btn primary-btn rounded-8 w-100 gap-2"
                    //   data-bs-dismiss="modal"
                    onClick={() => {
                      addRemoveTagHandler("1");
                    }}
                  >
                    <i className="material-icons-round fs-lg">check_circle</i>
                    <span>Add</span>
                  </Link>
                </div>
                <div className="add_btn w-50">
                  <Link
                    to="#"
                    className="btn rounded-8 w-100 gap-2"
                    onClick={() => {
                      addRemoveTagHandler("0");
                    }}
                  >
                    <i className="material-icons-round fs-lg">delete</i>
                    <span>Remove</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTagModal;
